import React, { useState } from 'react';
import Moment from 'react-moment';
import { makeStyles } from '@material-ui/core/styles';
import ScheduleIcon from '@material-ui/icons/Schedule';
import RoomIcon from '@material-ui/icons/Room';


const eventDateStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    eventWrapper: {
        display: 'flex',
        width: '500px',
        alignItems: 'center',
        paddingBottom: '20px'

    },
    eventDate: {
        width: '70px',
        height: '70px',
        borderRadius: '10%',
        background: 'var(--darkBlue)',
        color: 'var(--white)',  
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        marginRight: '10px',
        padding: '10px',
        flexDirection: 'column',
        fontWeight: 'bold',

    },
    single: {
        fontSize: '1.2rem',
        lineHeight: '1.5rem',
    },
    eventDetails: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: '70px'
    },
    eventRow: {
        display: 'flex',        
        justifyContent: 'flex-start',
        gap: '5px'
    }
}));
const isMultiday = (event) => {
    if (!event.eventStartDate || !event.eventEndDate) {
        return false;
    }

    return (
        event.eventStartDate.slice(0, 10) !==
        event.eventEndDate.slice(0, 10)
    );
};
const EventDates = (props) => {
    const classes = eventDateStyles();
    const { eventDates } = props;

    return (
        <>{eventDates.map((item) => (
            <div className={classes.eventWrapper} key={item.id}>
                <div className={classes.eventDate}>{isMultiday(item) ? <>
                    <Moment format="D MMM">
                         {item.eventStartDate}
                    </Moment>
                    {" to "}
                    <Moment format="D MMM">
                        {item.eventEndDate}
                    </Moment>
                </> : <Moment format="D MMM" className={classes.single}>{item.eventStartDate}</Moment>}</div>
                <div className={classes.eventDetails}>
                    <div><strong>{item.sessionName}</strong></div>
                    <div className={classes.eventRow}>
                        <ScheduleIcon style={{ fontSize: "1.2rem", }} />
                        {isMultiday(item) ? <><Moment format="D MMM YYYY h.mm a">{item.eventStartDate}</Moment> - <Moment format="D MMM YYYY h.mm a">{item.eventEndDate}</Moment></> : <><Moment format="D MMM YYYY">{item.eventStartDate}</Moment> <Moment format="h.mm a">{item.eventStartDate}</Moment> - <Moment format="h.mm a">{item.eventEndDate}</Moment></>}
                    </div>                  
                  
                    <div className={classes.eventRow}>
                        {item.eventLocation || item.eventLinkURL ? <RoomIcon style={{ fontSize: "1.2rem",  }} /> : null}
                        {item.eventLocation ? <div>{item.eventLocation}</div> : null}
                        {item.eventLocation && item.eventLinkURL ? " | " : null}
                        {item.eventLinkURL ? <div><a href={item.eventLinkURL}>{item.eventLinkText}</a></div>: null}
                    </div>
                </div>
              </div>         
        ))}</>
    );
};

export default EventDates;
